import React from 'react';
import CRMFollowupListConfigModal from './CRMFollowupListConfigModal';

/**
 * Modal avançado para listas extras do projeto Gas Distributor.
 * Reaproveita o modal completo de automações para habilitar:
 * - mensagem automática (texto/IA)
 * - imagens e áudio automáticos
 * - botões/link
 * - regras de follow-up
 * - encaminhamento/arquivamento
 */
export default function GasDistributorExtraListConfigModal(props) {
  return <CRMFollowupListConfigModal {...props} />;
}
